/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { ref, get, set, update } from "firebase/database";
import { storage, database } from "../firebase"; // Adjust the path to your Firebase configuration
import {
  FaLinkedin,
  FaTwitter,
  FaInstagram,
  FaFacebook,
  FaGithub,
} from "react-icons/fa";
import { toast } from "react-toastify";
import {
  ref as storageRef,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

import manImage from "../man.png";

const ProfilePage = ({ user }) => {
  const [awards, setAwards] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setlastName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactTelphone, setContactTelphone] = useState("");
  const [profilePicture, setProfilePicture] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [googleMap, setGoogleMap] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [address, setAddress] = useState("");
  const [socialLinks, setSocialLinks] = useState({
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
    github: "",
    youtube: "",
    website: "",
    reaProfile: "",
    RateMyAgent: "",
  });
  const [locationData, setLocationData] = useState(null); // Store full JSON data for selected location
  const [searchResults, setSearchResults] = useState([]); // Store search results for dropdown
  const [prevSearch, setPrevSearch] = useState(""); // Store previous search value

  //Upload function of file
  const uploadFile = async (file, folder) => {
    const fileRef = storageRef(storage, `${folder}/${file.name}`);
    const uploadTask = uploadBytesResumable(fileRef, file);

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        null,
        (error) => reject(error),
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
        }
      );
    });
  };

  const handleSearch = (searchValue) => {
    if (searchValue.trim() && searchValue !== prevSearch) {
      setGoogleMap(searchValue);
      setPrevSearch(searchValue);

      const apiKey = "AIzaSyB1i-fQWxI7lnWHXr_YjrM5OwygCKJVY5g"; // Replace with your actual API key

      fetch(
        `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${searchValue}&key=${apiKey}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.predictions && data.predictions.length > 0) {
            setSearchResults(data.predictions);
          } else {
            setSearchResults([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching location data:", error);
          setSearchResults([]);
        });
    }
  };

  const handleSelectLocation = (location) => {
    setGoogleMap(location.display_name);
    setLocationData(location);
    setSearchResults([]);
  };
  const markFirstLoginComplete = async (uid) => {
    const userRef = ref(database, `users/${uid}`);
    await update(userRef, { isFirstLogin: false });
  };
  useEffect(() => {
    if (user?.isFirstLogin) {
      markFirstLoginComplete(user?.uid);
    }
    const fetchData = async () => {
      const storedUserUID = user?.uid;
      if (storedUserUID) {
        // Step 1: Fetch user data from the 'users' table
        const userRef = ref(database, "users/" + storedUserUID); // Corrected reference to 'users/{userUID}'
        await update(userRef, { isFirstLogin: false });
        const userSnapshot = await get(userRef);
        if (userSnapshot.exists()) {
          const user = userSnapshot.val();
          setContactEmail(user.email);
          const companyId = user.companyId;
          if (companyId) {
            // Step 2: Fetch company data using the companyId
            const companyRef = ref(database, "companies/" + companyId); // Corrected reference to 'companies/{companyId}'
            const companySnapshot = await get(companyRef);

            if (companySnapshot.exists()) {
              const company = companySnapshot.val();
              setCompanyName(company.companyName || "");
              setContactTelphone(company.contactNumber || "");
            } else {
              console.error("Company not found");
              setCompanyName(""); // Optionally set an empty string or handle gracefully
            }

            // Step 3: Fetch profile data after successfully fetching the company
            const profileRef = ref(database, "profiles/" + storedUserUID);
            try {
              const profileSnapshot = await get(profileRef);
              if (profileSnapshot.exists()) {
                const profile = profileSnapshot.val();

                setFirstName(profile.firstName || "");
                setMiddleName(profile.middleName || "");
                setlastName(profile.lastName || "");
                setJobTitle(profile.jobTitle || "");
                setContactEmail(profile.contactEmail || "");
                setContactPhone(profile.contactPhone || "");
                setProfilePicture(profile.profilePicture || "");
                setGoogleMap(profile.googleMap || "");
                setDateOfBirth(profile.dateOfBirth || "");
                setAddress(profile.address || "");
                setAwards(profile.awards || "");
                setSocialLinks(
                  profile.socialLinks || {
                    linkedin: "",
                    twitter: "",
                    instagram: "",
                    facebook: "",
                    github: "",
                    youtube: "",
                    website: "www.multidynamic.com.au",
                    reaProfile: "",
                    RateMyAgent: "",
                  }
                );
              } else {
                console.error("Profile not found");
              }
            } catch (error) {
              console.error("Error fetching profile data:", error);
            }
          } else {
            console.error("Company ID not found in user data");
          }
        } else {
          console.error("User not found");
        }
      } else {
        console.error("No userUID found in localStorage");
      }
    };

    fetchData();
  }, [user]);

  const handleSave = async () => {
    const storedUserUID = user?.uid;
    if (storedUserUID) {
      const userRef = ref(database, "profiles/" + storedUserUID);
      try {
        await set(userRef, {
          userId: storedUserUID,
          firstName,
          middleName,
          lastName,
          jobTitle,
          contactEmail,
          contactPhone,
          contactTelphone,
          profilePicture,
          companyName,
          googleMap,
          dateOfBirth,
          address,
          socialLinks,
          awards,
        });
        toast.success("Profile created successfully!");
      } catch (error) {
        toast.error("Failed to save profile. Please try again.");
        console.error("Error saving profile:", error);
      }
    } else {
      toast.error("User not logged in. Please log in first.");
    }
  };

  const handleSocialLinkChange = (platform, value) => {
    setSocialLinks((prevLinks) => ({
      ...prevLinks,
      [platform]: value,
    }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0]; // Get the selected file
    if (!file) return;
    debugger;
    try {
      const url = await uploadFile(file, "profiles"); // Upload the single file
      setProfilePicture(url); // Set the uploaded URL
      console.log("Uploaded URL:", url);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleAwardsUpload = async (e) => {
    const files = Array.from(e.target.files);
    const uploadedAwardUrls = [];

    for (const file of files) {
      const uploadedUrl = await uploadFile(file, "awards");
      uploadedAwardUrls.push(uploadedUrl);
    }

    setAwards(uploadedAwardUrls);
  };

  //const profileURL = `${window.location.origin}/digitalCard/${localStorage.getItem('userUID')}`;

  return (
    <div className="container mx-auto flex justify-center mt-10 pb-10  relative flex-wrap md:flex-nowrap ">
      {/* Digital Card Section */}
      <div className="w-full sm:w-full md:w-2/5 px-8">
        {/* Buttons Section */}
        <div className="mb-8 flex justify-center">
          {/* Preview Button */}
          <button
            onClick={() => {
              const userId = user?.uid;
              if (userId) {
                const middleNameSegment = middleName ? middleName : ""; // Keep empty string if no middleName
                const fullName = `${firstName}-${
                  middleNameSegment ? middleNameSegment + "-" : ""
                }${lastName}`;

                const url = `/digitalCard/${companyName}/${fullName}`;
                window.open(url, "_blank");
              } else {
                console.error("User not found");
              }
            }}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-700 transition w-full sm:w-4/5"
          >
            Digital Card Preview
          </button>
        </div>
        <div className="flex-col hidden sm:block">
          <div className="section relative text-center mb-8 w-full max-w-sm mx-auto rounded-lg shadow-xl">
            {/* Background Image Section */}
            <div
              className="bg-center bg-cover bg-no-repeat w-full min-h-[35rem] sm:min-h-[25rem] md:min-h-[30rem] rounded-lg relative"
              style={{
                backgroundImage: `url(${profilePicture || manImage})`,
              }}
            >
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-black/60 via-transparent/50 to-transparent/0 rounded-lg"></div>

              {/* Profile Details Section - Positioned at Bottom */}
              <div className="absolute bottom-0 w-full p-4 text-white text-left flex flex-col bg-gradient-to-t from-black via-transparent to-transparent rounded-b-lg">
                {/* Profile Name and Information */}
                <h1 className="text-3xl font-semibold mb-2">
                  {firstName || "First"} {middleName || ""} {lastName || "Last"}
                </h1>
                <p className="mb-1">{companyName || "CompanyName"}</p>
                <p className="mb-4">{address || "No address available"}</p>

                {/* Contact Icons - Left Aligned */}
                <div>
                  <ul className="flex space-x-4">
                    {contactPhone && (
                      <li>
                        <a
                          href={`tel:${contactPhone}`}
                          className="btn w-12 h-12 bg-[#3d0fd5] rounded-full flex items-center justify-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-white"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                            />
                          </svg>
                        </a>
                      </li>
                    )}
                    {contactTelphone && (
                      <li>
                        <a
                          href={`tel:${contactTelphone}`}
                          className="btn w-12 h-12 bg-[#3d0fd5] rounded-full flex items-center justify-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-white"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                            />
                          </svg>
                        </a>
                      </li>
                    )}
                    {contactEmail && (
                      <li>
                        <a
                          href={`mailto:${contactEmail}`}
                          className="btn w-12 h-12 bg-[#3d0fd5] rounded-full flex items-center justify-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-white"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                            />
                          </svg>
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-white rounded-lg shadow-lg p-6 mb-4 w-full max-w-sm  mx-auto">
            <h2 class="text-xl mb-4 text-black text-left font-bold">
              My Quick Links
            </h2>
            {/* 
        <!-- Social Media Links --> */}
            {/* LinkedIn */}
            {socialLinks.linkedin && (
              <a
                href={socialLinks.linkedin}
                target="_blank"
                rel="noreferrer noopener"
                className="flex items-center justify-between p-2 hover:bg-gray-200 rounded"
              >
                <div className="flex items-center gap-3 text-black">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="30"
                    height="30"
                    viewBox="0 0 50 50"
                  >
                    <path d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M17,20v19h-6V20H17z M11,14.47c0-1.4,1.2-2.47,3-2.47s2.93,1.07,3,2.47c0,1.4-1.12,2.53-3,2.53C12.2,17,11,15.87,11,14.47z M39,39h-6c0,0,0-9.26,0-10 c0-2-1-4-3.5-4.04h-0.08C27,24.96,26,27.02,26,29c0,0.91,0,10,0,10h-6V20h6v2.56c0,0,1.93-2.56,5.81-2.56 c3.97,0,7.19,2.73,7.19,8.26V39z"></path>
                  </svg>
                  <p className="font-medium text-black">LinkedIn</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M9 5l7 7-7 7" />
                </svg>
              </a>
            )}

            {/* Twitter */}
            {socialLinks.twitter && (
              <a
                href={socialLinks.twitter}
                target="_blank"
                rel="noreferrer noopener"
                className="flex items-center justify-between p-2 hover:bg-gray-200 rounded"
              >
                <div className="flex items-center gap-3 text-black">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="30"
                    height="30"
                    viewBox="0 0 50 50"
                  >
                    <path d="M 11 4 C 7.134 4 4 7.134 4 11 L 4 39 C 4 42.866 7.134 46 11 46 L 39 46 C 42.866 46 46 42.866 46 39 L 46 11 C 46 7.134 42.866 4 39 4 L 11 4 z M 13.085938 13 L 21.023438 13 L 26.660156 21.009766 L 33.5 13 L 36 13 L 27.789062 22.613281 L 37.914062 37 L 29.978516 37 L 23.4375 27.707031 L 15.5 37 L 13 37 L 22.308594 26.103516 L 13.085938 13 z M 16.914062 15 L 31.021484 35 L 34.085938 35 L 19.978516 15 L 16.914062 15 z"></path>
                  </svg>
                  <p className="font-medium text-black">Twitter</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M9 5l7 7-7 7" />
                </svg>
              </a>
            )}

            {/* Instagram */}
            {socialLinks.instagram && (
              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noreferrer noopener"
                class="flex items-center justify-between p-2 hover:bg-gray-200 rounded"
              >
                <div class="flex items-center gap-3 text-black">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="30"
                    height="30"
                    viewBox="0 0 50 50"
                  >
                    <path d="M 16 3 C 8.83 3 3 8.83 3 16 L 3 34 C 3 41.17 8.83 47 16 47 L 34 47 C 41.17 47 47 41.17 47 34 L 47 16 C 47 8.83 41.17 3 34 3 L 16 3 z M 37 11 C 38.1 11 39 11.9 39 13 C 39 14.1 38.1 15 37 15 C 35.9 15 35 14.1 35 13 C 35 11.9 35.9 11 37 11 z M 25 14 C 31.07 14 36 18.93 36 25 C 36 31.07 31.07 36 25 36 C 18.93 36 14 31.07 14 25 C 14 18.93 18.93 14 25 14 z M 25 16 C 20.04 16 16 20.04 16 25 C 16 29.96 20.04 34 25 34 C 29.96 34 34 29.96 34 25 C 34 20.04 29.96 16 25 16 z"></path>
                  </svg>
                  <p class="font-medium text-black">Instagram</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M9 5l7 7-7 7" />
                </svg>
              </a>
            )}

            {/* Facebook */}
            {socialLinks.facebook && (
              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noreferrer noopener"
                class="flex items-center justify-between p-2 hover:bg-gray-200 rounded"
              >
                <div class="flex items-center gap-3 text-black">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="30"
                    height="30"
                    viewBox="0 0 50 50"
                  >
                    <path d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M37,19h-2c-2.14,0-3,0.5-3,2 v3h5l-1,5h-4v15h-5V29h-4v-5h4v-3c0-4,2-7,6-7c2.9,0,4,1,4,1V19z"></path>
                  </svg>
                  <p class="font-medium text-black">Facebook</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M9 5l7 7-7 7" />
                </svg>
              </a>
            )}

            {/* GitHub */}
            {socialLinks.github && (
              <a
                href={socialLinks.github}
                target="_blank"
                rel="noreferrer noopener"
                class="flex items-center justify-between p-2 hover:bg-gray-200 rounded"
              >
                <div class="flex items-center gap-3 text-black">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="30"
                    height="30"
                    viewBox="0 0 50 50"
                  >
                    <path d="M17.791,46.836C18.502,46.53,19,45.823,19,45v-5.4c0-0.197,0.016-0.402,0.041-0.61C19.027,38.994,19.014,38.997,19,39 c0,0-3,0-3.6,0c-1.5,0-2.8-0.6-3.4-1.8c-0.7-1.3-1-3.5-2.8-4.7C8.9,32.3,9.1,32,9.7,32c0.6,0.1,1.9,0.9,2.7,2c0.9,1.1,1.8,2,3.4,2 c2.487,0,3.82-0.125,4.622-0.555C21.356,34.056,22.649,33,24,33v-0.025c-5.668-0.182-9.289-2.066-10.975-4.975 c-3.665,0.042-6.856,0.405-8.677,0.707c-0.058-0.327-0.108-0.656-0.151-0.987c1.797-0.296,4.843-0.647,8.345-0.714 c-0.112-0.276-0.209-0.559-0.291-0.849c-3.511-0.178-6.541-0.039-8.187,0.097c-0.02-0.332-0.047-0.663-0.051-0.999 c1.649-0.135,4.597-0.27,8.018-0.111c-0.079-0.5-0.13-1.011-0.13-1.543c0-1.7,0.6-3.5,1.7-5c-0.5-1.7-1.2-5.3,0.2-6.6 c2.7,0,4.6,1.3,5.5,2.1C21,13.4,22.9,13,25,13s4,0.4,5.6,1.1c0.9-0.8,2.8-2.1,5.5-2.1c1.5,1.4,0.7,5,0.2,6.6c1.1,1.5,1.7,3.2,1.6,5 c0,0.484-0.045,0.951-0.11,1.409c3.499-0.172,6.527-0.034,8.204,0.102c-0.002,0.337-0.033,0.666-0.051,0.999 c-1.671-0.138-4.775-0.28-8.359-0.089c-0.089,0.336-0.197,0.663-0.325,0.98c3.546,0.046,6.665,0.389,8.548,0.689 c-0.043,0.332-0.093,0.661-0.151,0.987c-1.912-0.306-5.171-0.664-8.879-0.682C35.112,30.873,31.557,32.75,26,32.969V33 c2.6,0,5,3.9,5,6.6V45c0,0.823,0.498,1.53,1.209,1.836C41.37,43.804,48,35.164,48,25C48,12.318,37.683,2,25,2S2,12.318,2,25 C2,35.164,8.63,43.804,17.791,46.836z"></path>
                  </svg>
                  <p class="font-medium text-black">GitHub</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M9 5l7 7-7 7" />
                </svg>
              </a>
            )}

            {/* YouTube */}
            {socialLinks.youtube && (
              <a
                href={socialLinks.youtube}
                target="_blank"
                rel="noreferrer noopener"
                class="flex items-center justify-between p-2 hover:bg-gray-200 rounded"
              >
                <div class="flex items-center gap-3 text-black">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="30"
                    height="30"
                    viewBox="0 0 50 50"
                  >
                    <path d="M 44.898438 14.5 C 44.5 12.300781 42.601563 10.699219 40.398438 10.199219 C 37.101563 9.5 31 9 24.398438 9 C 17.800781 9 11.601563 9.5 8.300781 10.199219 C 6.101563 10.699219 4.199219 12.199219 3.800781 14.5 C 3.398438 17 3 20.5 3 25 C 3 29.5 3.398438 33 3.898438 35.5 C 4.300781 37.699219 6.199219 39.300781 8.398438 39.800781 C 11.898438 40.5 17.898438 41 24.5 41 C 31.101563 41 37.101563 40.5 40.601563 39.800781 C 42.800781 39.300781 44.699219 37.800781 45.101563 35.5 C 45.5 33 46 29.398438 46.101563 25 C 45.898438 20.5 45.398438 17 44.898438 14.5 Z M 19 32 L 19 18 L 31.199219 25 Z"></path>
                  </svg>
                  <p class="font-medium text-black">YouTube</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M9 5l7 7-7 7" />
                </svg>
              </a>
            )}

            {/* Website */}
            {socialLinks.website && (
              <a
                href={socialLinks.website}
                target="_blank"
                rel="noreferrer noopener"
                class="flex items-center justify-between p-2 hover:bg-gray-200 rounded"
              >
                <div class="flex items-center gap-3 text-black">
                  <svg
                    width="30px"
                    height="30px"
                    viewBox="0 0 64 64"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke-width="3"
                    stroke="#000000"
                    fill="none"
                  >
                    <path d="M39.93,55.72A24.86,24.86,0,1,1,56.86,32.15a37.24,37.24,0,0,1-.73,6" />
                    <path d="M37.86,51.1A47,47,0,0,1,32,56.7" />
                    <path d="M32,7A34.14,34.14,0,0,1,43.57,30a34.07,34.07,0,0,1,.09,4.85" />
                    <path d="M32,7A34.09,34.09,0,0,0,20.31,32.46c0,16.2,7.28,21,11.66,24.24" />
                    <line x1="10.37" y1="19.9" x2="53.75" y2="19.9" />
                    <line x1="32" y1="6.99" x2="32" y2="56.7" />
                    <line x1="11.05" y1="45.48" x2="37.04" y2="45.48" />
                    <line x1="7.14" y1="32.46" x2="56.86" y2="31.85" />
                    <path d="M53.57,57,58,52.56l-8-8,4.55-2.91a.38.38,0,0,0-.12-.7L39.14,37.37a.39.39,0,0,0-.46.46L42,53.41a.39.39,0,0,0,.71.13L45.57,49Z" />
                  </svg>
                  <p class="font-medium text-black">Website</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M9 5l7 7-7 7" />
                </svg>
              </a>
            )}

            {/* REA Profile */}
            {socialLinks.reaProfile && (
              <a
                href={socialLinks.reaProfile}
                target="_blank"
                rel="noreferrer noopener"
                class="flex items-center justify-between p-2 hover:bg-gray-200 rounded"
              >
                <div class="flex items-center gap-3 text-black">
                  <svg
                    fill="#000000"
                    width="30"
                    height="30"
                    viewBox="0 0 50 50"
                    version="1.2"
                    baseProfile="tiny"
                    xmlns="http://www.w3.org/2000/svg"
                    overflow="inherit"
                  >
                    <path d="M14.237 39.5h30.483v-26.081h-30.483v26.081zm15.489-23.485l10.99 9.598h-2.769v11.516h-6.436v-8.129h-4.065v8.129h-6.096v-11.516h-2.84l11.216-9.598zm-18.876-9.031v-5.966h-6.774v48.982h6.774v-39.967h35.226v-3.049z" />
                  </svg>
                  <p class="font-medium text-black">REA Profile</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M9 5l7 7-7 7" />
                </svg>
              </a>
            )}
            {/* RateMyAgent Profile */}
            {socialLinks.RateMyAgent && (
              <a
                href={socialLinks.RateMyAgent}
                target="_blank"
                rel="noreferrer noopener"
                class="flex items-center justify-between p-2 hover:bg-gray-200 rounded"
              >
                <div class="flex items-center gap-3 text-black">
                  {/* RateMyAgent Icon (SVG) */}
                  <svg
                    class="h-8 w-8 text-gray-400"
                    viewBox="0 0 24 24"
                    fill="black"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 2l2.39 7.26H22l-6.19 4.63 2.39 7.26L12 16.52l-6.19 4.63 2.39-7.26L2 9.26h7.61z" />
                  </svg>

                  <p class="font-medium text-black">Rate My Agent</p>
                </div>

                {/* Arrow icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M9 5l7 7-7 7" />
                </svg>
              </a>
            )}
          </div>
        </div>
      </div>

      {/* Profile Setup Section */}
      <div className="w-full px-8 md:px-16 sm:px-4">
        <h3 className="text-xl">Profile</h3>
        <hr className="mb-6 " />
        <form>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* Profile Picture */}
            <div className="mb-4">
              <label
                htmlFor="profilePicture"
                className="block text-sm font-medium text-gray-700"
              >
                Profile Picture
              </label>
              <input
                id="profilePicture"
                type="file"
                accept="image/*"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                onChange={handleFileChange}
              />
            </div>
            {/* Company Name */}
            {/* <div className="mb-4">
              <label
                htmlFor="companyName"
                className="block text-sm font-medium text-gray-700"
              >
                Company Name
              </label>
              <input
                id="companyName"
                type="text"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                disabled
              />
            </div> */}
            {/* Job Title */}
            <div className="mb-4">
              <label
                htmlFor="jobTitle"
                className="block text-sm font-medium text-gray-700"
              >
                Job Title
              </label>
              <input
                id="jobTitle"
                type="text"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                value={jobTitle}
                onChange={(e) => setJobTitle(e.target.value)}
              />
            </div>
            {/* First Name */}
            <div className="mb-4">
              <label
                htmlFor="firstName"
                className="block text-sm font-medium text-gray-700"
              >
                First Name
              </label>
              <input
                id="firstName"
                type="text"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            {/* Middle Name */}
            <div className="mb-4">
              <label
                htmlFor="middleName"
                className="block text-sm font-medium text-gray-700"
              >
                Middle Name
              </label>
              <input
                id="middleName"
                type="text"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                value={middleName}
                onChange={(e) => setMiddleName(e.target.value)}
              />
            </div>
            {/* Last Name */}
            <div className="mb-4">
              <label
                htmlFor="lastName"
                className="block text-sm font-medium text-gray-700"
              >
                Last Name
              </label>
              <input
                id="lastName"
                type="text"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                value={lastName}
                onChange={(e) => setlastName(e.target.value)}
              />
            </div>
            {/* Email Address */}
            {/* <div className="mb-4">
              <label
                htmlFor="contactEmail"
                className="block text-sm font-medium text-gray-700"
              >
                Email Address
              </label>
              <input
                id="contactEmail"
                type="email"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                value={contactEmail}
                onChange={(e) => setContactEmail(e.target.value)}
                disabled
              />
            </div> */}
            {/* Phone Number */}
            <div className="mb-4">
              <label
                htmlFor="contactPhone"
                className="block text-sm font-medium text-gray-700"
              >
                Phone Number
              </label>
              <input
                id="contactPhone"
                type="text"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                value={contactPhone}
                onChange={(e) => setContactPhone(e.target.value)}
              />
            </div>
            {/* Phone Number */}
            {/* <div className="mb-4">
              <label
                htmlFor="contactTelphone"
                className="block text-sm font-medium text-gray-700"
              >
                Telphone
              </label>
              <input
                id="contactTelphone"
                type="text"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                value={contactTelphone}
                onChange={(e) => setContactTelphone(e.target.value)}
              />
            </div> */}

            {/* Date of Birth */}
            <div className="mb-4">
              <label
                htmlFor="dateOfBirth"
                className="block text-sm font-medium text-gray-700"
              >
                Date of Birth
              </label>
              <input
                id="dateOfBirth"
                type="date"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                value={dateOfBirth}
                onChange={(e) => setDateOfBirth(e.target.value)}
              />
            </div>
            {/* Address */}
            <div className="mb-4">
              <label
                htmlFor="address"
                className="block text-sm font-medium text-gray-700"
              >
                Address
              </label>
              <input
                id="address"
                type="text"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>

            <div className="mb-4 relative">
              {/* Input Field */}
              <label
                htmlFor="googleMap"
                className="block text-sm font-medium text-gray-700"
              >
                Location
              </label>
              <input
                id="googleMap"
                type="text"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                value={googleMap} // Show selected name in the input field
                onChange={(e) => handleSearch(e.target.value)} // Update search as user types
                placeholder="Search for a location"
              />

              {/* Dropdown for search results */}
              {searchResults.length > 0 && (
                <ul className="absolute mt-1 sm:w-56 md:w-96 bg-white border border-gray-300 rounded-lg shadow-lg z-10">
                  {searchResults.map((location, index) => (
                    <li
                      key={index}
                      className="px-3 py-2 text-sm sm:text-base hover:bg-gray-100 cursor-pointer"
                      onClick={() => handleSelectLocation(location)} // Select the location
                    >
                      {location.display_name} {/* Show the address */}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          {/* Social Media Links */}
          <div className="mt-6">
            <h3 className="text-xl ">Social Media Links</h3>
            <hr className="mb-6 " />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* LinkedIn */}
              <div className="mb-4">
                <label
                  htmlFor="linkedin"
                  className="block text-sm font-medium text-gray-700"
                >
                  LinkedIn
                </label>
                <input
                  id="linkedin"
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                  value={socialLinks.linkedin}
                  onChange={(e) =>
                    handleSocialLinkChange("linkedin", e.target.value)
                  }
                />
              </div>
              {/* Twitter */}
              <div className="mb-4">
                <label
                  htmlFor="twitter"
                  className="block text-sm font-medium text-gray-700"
                >
                  Twitter
                </label>
                <input
                  id="twitter"
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                  value={socialLinks.twitter}
                  onChange={(e) =>
                    handleSocialLinkChange("twitter", e.target.value)
                  }
                />
              </div>
              {/* Instagram */}
              <div className="mb-4">
                <label
                  htmlFor="instagram"
                  className="block text-sm font-medium text-gray-700"
                >
                  Instagram
                </label>
                <input
                  id="instagram"
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                  value={socialLinks.instagram}
                  onChange={(e) =>
                    handleSocialLinkChange("instagram", e.target.value)
                  }
                />
              </div>
              {/* facebook */}
              <div className="mb-4">
                <label
                  htmlFor="facebook"
                  className="block text-sm font-medium text-gray-700"
                >
                  Facebook
                </label>
                <input
                  id="facebook"
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                  value={socialLinks.facebook}
                  onChange={(e) =>
                    handleSocialLinkChange("facebook", e.target.value)
                  }
                />
              </div>
              {/* GitHub */}
              <div className="mb-4">
                <label
                  htmlFor="github"
                  className="block text-sm font-medium text-gray-700"
                >
                  GitHub
                </label>
                <input
                  id="github"
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                  value={socialLinks.github || ""}
                  onChange={(e) =>
                    handleSocialLinkChange("github", e.target.value)
                  }
                />
              </div>
              {/* YouTube */}
              <div className="mb-4">
                <label
                  htmlFor="youtube"
                  className="block text-sm font-medium text-gray-700"
                >
                  YouTube
                </label>
                <input
                  id="youtube"
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                  value={socialLinks.youtube || ""}
                  onChange={(e) =>
                    handleSocialLinkChange("youtube", e.target.value)
                  }
                />
              </div>
              {/* Website */}
              <div className="mb-4">
                <label
                  htmlFor="website"
                  className="block text-sm font-medium text-gray-700"
                >
                  Website
                </label>
                <input
                  id="website"
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                  value={socialLinks.website || ""}
                  onChange={(e) =>
                    handleSocialLinkChange("website", e.target.value)
                  }
                />
              </div>
              {/* reaProfile */}
              <div className="mb-4">
                <label
                  htmlFor="reaProfile"
                  className="block text-sm font-medium text-gray-700"
                >
                  Rea Profile
                </label>
                <input
                  id="reaProfile"
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                  value={socialLinks.reaProfile || ""}
                  onChange={(e) =>
                    handleSocialLinkChange("reaProfile", e.target.value)
                  }
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="RateMyAgent"
                  className="block text-sm font-medium text-gray-700"
                >
                  Rate My Agent Link
                </label>
                <input
                  id="RateMyAgent"
                  type="text"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg mt-2"
                  value={socialLinks.RateMyAgent}
                  onChange={(e) =>
                    handleSocialLinkChange("RateMyAgent", e.target.value)
                  }
                />
              </div>
            </div>
          </div>
          {/* Awards Section */}
          <div className="flex flex-col items-start justify-end">
            <label className="text-sm font-medium text-gray-700">Awards</label>
            <div className="mt-4">
              {awards.length > 0 && (
                <ul className="flex space-x-4">
                  {awards.map((award, index) => (
                    <li key={index}>
                      <img
                        src={award}
                        alt={`Award ${index + 1}`}
                        className="w-20 h-20 rounded-sm border-2 border-gray-300 object-contain mb-2 transition-transform duration-300 ease-in-out hover:scale-110"
                      />
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleAwardsUpload}
              className="bg-gray-100 text-gray-700 file:border file:border-gray-400 file:rounded-lg file:px-2 file:py-1 file:hover:bg-gray-200 file:hover:border-blue-500 transition-all"
            />
          </div>
          <div className="flex items-center justify-start my-2">
            <button
              type="button"
              onClick={handleSave}
              className="bg-gray-800 text-white py-2 px-6 rounded-sm hover:bg-gray-900"
            >
              Save Profile
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProfilePage;
